import { useState } from "react";
import axios from "axios";
import { Container, Form, Button, Card, Alert, Spinner } from "react-bootstrap";
import "../styles/TrackOrder.css"; // Optional

const TrackOrder = () => {
  const [code, setCode] = useState("");
  const [tracking, setTracking] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleTrack = async (e) => {
    e.preventDefault();
    setTracking(null);
    setError("");
    setLoading(true);
    const API_BASE = process.env.REACT_APP_API_BASE_URL;

    try {
      const token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${token}` };
      const res = await axios.get(`${API_BASE}/api/track/${code}`,{headers});
      setTracking(res.data);
    } catch (err) {
      setError(err.response?.data?.error || "Unable to track order.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="mt-5 track-container">
      <h2 className="text-center mb-4 text-primary">Track Your Order</h2>
      
      <Form onSubmit={handleTrack} className="mb-4">
        <Form.Group className="mb-3">
          <Form.Label>Enter Tracking Code</Form.Label>
          <Form.Control
            type="text"
            placeholder="e.g., SALPITA-12345"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            required
          />
        </Form.Group>
        <Button type="submit" variant="primary" disabled={loading}>
          {loading ? <Spinner animation="border" size="sm" /> : "Track Order"}
        </Button>
      </Form>

      {error && <Alert variant="danger">{error}</Alert>}

      {tracking && (
        <Card className="shadow-sm">
          <Card.Body>
            <h5>Tracking Code: <span className="text-success">{tracking.tracking_code}</span></h5>
            <p><strong>Status:</strong> {tracking.status}</p>
            <p><strong>Info:</strong> {tracking.info || "No updates yet."}</p>
            <hr />
            <p><strong>Order ID:</strong> {tracking.order_id}</p>
            <p><strong>Order Date:</strong> {tracking.created_at}</p>
            <p><strong>Delivery Date:</strong> {tracking.delivery_date}</p>
            
          </Card.Body>
        </Card>
      )}
    </Container>
  );
};

export default TrackOrder;
